import {
    GET_RECIPIENTS_ERROR,
    GET_RECIPIENTS_START,
    GET_RECIPIENTS_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.devices.recipients, action = {type: ''}) => {
    switch (action.type) {
        case GET_RECIPIENTS_START:
            return {
                ...state,
                error: false,
                loading: true,
            };
        case GET_RECIPIENTS_SUCCESS:
            return {
                ...state,
                list: action.payload,
                loading: false,
            };
        case GET_RECIPIENTS_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
                list: [],
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/deviceReducer/getRecipientsReducer.js